import { usingGet } from '@ocean/api'

export const getCourseDetails = (courseId: Guid, resultId?: Guid) => {
  const baseUrl = `courses/details/${courseId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}
